import type { CreateSkillRequest } from '../services/skillService'

/**
 * The create form's vocabulary and its one mapping to the API (Skills UX pass
 * 2026-09-06). A title is enough; nothing optional is sent when it was not said.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SkillFormData = Record<string, any>

export function skillFormToPayload(form: SkillFormData): CreateSkillRequest {
  const parentId = form.parent_id ? Number(form.parent_id) : null
  const areas: string[] = Array.isArray(form.life_areas) ? form.life_areas.map(String).filter(Boolean) : []
  const payload: CreateSkillRequest = {
    title: String(form.title || '').trim(),
    priority: (form.priority || 'medium') as CreateSkillRequest['priority'],
    parent_goal_id: form.parent_type === 'goal' && parentId ? parentId : undefined,
    life_areas: !parentId && areas.length ? areas : undefined,
    life_area: !parentId && areas.length ? areas[0] : undefined,
    description: form.description?.trim?.() || undefined,
    current_level: form.current_level || undefined,
    target_level: form.target_level || undefined,
    target_date: form.target_date ? String(form.target_date).slice(0, 10) : undefined,
    practice_cadence: form.practice_cadence || undefined,
  }
  return payload
}
